export const showTotal =
  (isGrouped?: boolean) =>
  (total: number, [min, max]: [number, number]) =>
    (
      <div>{`Showing ${min}-${max} ${
        isGrouped ? 'grouped items ' : ''
      }of ${total} total items`}</div>
    );
